import api from "../services/api";

export const createAdminUser = async (data) => {
    try {
        const response = await api.post(`/admin/register`, data);
        return response;
    } catch (error) {
        console.error('Erro ao criar conta:', error?.response?.data);
        throw error;
    }
}

export const getAllAdminUsers = async () => {
    try {
        const response = await api.get(`/admin/users`);
        return response;
    } catch (error) {
        console.error('Erro ao exibir usuários:', error?.response?.data);
        throw error;
    }
}

export const adminUserEdit = async (id, data) => {
    try {
        const response = await api.patch(`/admin/${id}/`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao editar usuário:', error?.response?.data);
        throw error;
    }
}

export const updateSubscription = async (id, data) => {
    try {
        const response = await api.put(`/admin/subscription/${id}`, data);
        console.log(response?.data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar subscrição:', error?.response?.data);
        throw error;
    }
}

export const getAdminSelected = async (id) => {
    try {
        const response = await api.get(`/admin/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao obter usuário:', error?.response?.data);
        throw error;
    }
}

export const deleteAdminUser = async (id) => {
    try {
        const response = await api.delete(`/admin/delete/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar usuário:', error?.response?.data);
        throw error;
    }
}

// Exclusão de usuária a partir do painel — restrita no backend pra requireUserDeletePermission
// (só gestaonovaeradigital@gmail.com / alexandresaintss@gmail.com), diferente do delete
// comum de UserBusiness (que é self-delete, exige senha do próprio dono).
export const adminDeleteUser = async (id) => {
    try {
        const response = await api.delete(`/admin/users/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao excluir usuário:', error?.response?.data);
        throw error;
    }
}

export const updatePlanOverride = async (id, planOverride, planOverrideExpiresAt) => {
    try {
        const response = await api.put(`/admin/plan-override/${id}`, { planOverride, planOverrideExpiresAt });
        return response;
    } catch (error) {
        console.error('Erro ao atualizar planOverride:', error?.response?.data);
        throw error;
    }
}

// Liga/desliga os disparos (WhatsApp e e-mail) de uma conta. Só o push continua quando desligado.
export const updateDispatchConfig = async (id, dispatchesDisabled) => {
    try {
        const response = await api.put(`/admin/dispatch-config/${id}`, { dispatchesDisabled });
        return response;
    } catch (error) {
        console.error('Erro ao atualizar disparos:', error?.response?.data);
        throw error;
    }
}

// Programa de embaixadoras
export const getAmbassadors = async () => {
    try {
        const response = await api.get('/admin/ambassadors');
        return response;
    } catch (error) {
        console.error('Erro ao listar embaixadoras:', error?.response?.data);
        throw error;
    }
}

// data: { userId, code, disableDispatches }
export const createAmbassador = async (data) => {
    try {
        const response = await api.post('/admin/ambassadors', data);
        return response;
    } catch (error) {
        console.error('Erro ao cadastrar embaixadora:', error?.response?.data);
        throw error;
    }
}

// data: { code?, isAmbassador? }
export const updateAmbassador = async (id, data) => {
    try {
        const response = await api.put(`/admin/ambassadors/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar embaixadora:', error?.response?.data);
        throw error;
    }
}

export const updateEnterpriseConfig = async (id, data) => {
    try {
        const response = await api.put(`/admin/enterprise-config/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar configuração enterprise:', error?.response?.data);
        throw error;
    }
}

export const getAdmins = async () => {
    try {
        const response = await api.get(`/admin/admins`);
        return response;
    } catch (error) {
        console.error('Erro ao listar admins:', error?.response?.data);
        throw error;
    }
}

export const createAdminAccount = async (data) => {
    try {
        const response = await api.post(`/admin/admins`, data);
        return response;
    } catch (error) {
        console.error('Erro ao criar admin:', error?.response?.data);
        throw error;
    }
}

export const updateAdminAccount = async (id, data) => {
    try {
        const response = await api.put(`/admin/admins/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar admin:', error?.response?.data);
        throw error;
    }
}

export const deleteAdminAccount = async (id) => {
    try {
        const response = await api.delete(`/admin/admins/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar admin:', error?.response?.data);
        throw error;
    }
}

export const getAdminReports = async (params = {}) => {
    try {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/admin/reports${query ? '?' + query : ''}`);
        return response;
    } catch (error) {
        console.error('Erro ao buscar relatórios:', error?.response?.data);
        throw error;
    }
}
// Disparos manuais (e-mail/push) por plano
export const getBroadcastAudience = async () => {
    try {
        const response = await api.get('/admin/broadcasts/audience');
        return response;
    } catch (error) {
        console.error('Erro ao carregar público dos disparos:', error?.response?.data);
        throw error;
    }
}

export const getBroadcasts = async () => {
    try {
        const response = await api.get('/admin/broadcasts');
        return response;
    } catch (error) {
        console.error('Erro ao listar disparos:', error?.response?.data);
        throw error;
    }
}

// data: { title, body, channels: { email, push }, plans: [...] }
export const createBroadcast = async (data) => {
    try {
        const response = await api.post('/admin/broadcasts', data);
        return response;
    } catch (error) {
        console.error('Erro ao criar disparo:', error?.response?.data);
        throw error;
    }
}

// Envia o próximo lote do disparo — o painel chama em loop até status "done".
export const processBroadcast = async (id) => {
    try {
        const response = await api.post(`/admin/broadcasts/${id}/process`);
        return response;
    } catch (error) {
        console.error('Erro ao enviar lote do disparo:', error?.response?.data);
        throw error;
    }
}

// Importa um lote de linhas (serviços, estoque, clientes ou agendamentos) na conta da usuária.
// Só adiciona: o backend pula o que já existe. Ver ImportMinhaAgendaModal.
export const importForUser = async (userId, kind, rows, importToken) => {
    try {
        const response = await api.post(`/admin/users/${userId}/import/${kind}`, { rows }, { headers: { "x-import-token": importToken } });
        return response;
    } catch (error) {
        console.error(`Erro ao importar ${kind}:`, error?.response?.data);
        throw error;
    }
}

// Manda o código de autorização da importação pra dona da conta (channel: "whatsapp" | "email")
export const requestImportCode = async (userId, channel) => {
    try {
        const response = await api.post(`/admin/users/${userId}/import-code`, { channel });
        return response;
    } catch (error) {
        console.error('Erro ao pedir código de importação:', error?.response?.data);
        throw error;
    }
}

// Confere o código que a usuária passou; devolve o token exigido em cada lote da importação
export const verifyImportCode = async (userId, code) => {
    try {
        const response = await api.post(`/admin/users/${userId}/import-code/verify`, { code });
        return response;
    } catch (error) {
        console.error('Erro ao verificar código de importação:', error?.response?.data);
        throw error;
    }
}
